document.addEventListener("DOMContentLoaded", () => {
  let productCounter = $(
    ".comparison-box .product-img__inner .icon-close"
  ).length;

  // 移除产品的事件
  $(".comparison-box .product-img__inner .icon-close").on(
    "click",
    function (e) {
      const $this = $(this);
      const index = $this.closest(".comparison-item").index();
      $(
        `.filter-values .value-row>.comparison-item:nth-child(${index + 1})`
      ).remove();
      // const $emptyRowEl = $(`<div class="comparison-item product-img"></div>`);
      // $(`.filter-values .value-row`).append($emptyRowEl);

      // 更新页面 Url 地址
      const productsParmaStr = _getUrlQueryString(
        window.location.href,
        "filter.products"
      );
      const productsParmaList = productsParmaStr.split(",");
      productsParmaList.splice(
        productsParmaList.indexOf($this.attr("data-handle")),
        1
      );
      const newUrl = _replaceUrlParamValue(
        window.location.href,
        "filter.products",
        productsParmaList.toString()
      );
      history.pushState("", "", newUrl);

      console.log(newUrl);
      productCounter--;
      if (productCounter <= 2) {
        $(".comparison-box .product-img__inner .icon-close").hide();
        return;
      }
    }
  );

  (function () {
    // 左右翻动按钮
    const container = document.querySelector(".comparison-box .scroller");
    const $container = $(container);
    const $prevElement = $(`.scroll-btn-prev`);
    const $nextElement = $(`.scroll-btn-next`);

    // 检测浏览器是否支持平滑滚动
    const isSmoothScrollSupported = "scrollBehavior" in document.documentElement.style;

    $prevElement.on("click", () => {
      const left = $container.scrollLeft();
      if (isSmoothScrollSupported) {
        container.scrollTo({
          left: left - 200,
          behavior: "smooth",
        });
      } else {
        container.scrollLeft = left - 200;
      }
    });

    $nextElement.on("click", () => {
      const left = $container.scrollLeft();
      if (isSmoothScrollSupported) {
        container.scrollTo({
          left: left + 200,
          behavior: "smooth",
        });
      } else {
        container.scrollLeft = left + 200;
      }
    });

    function reloadButton() {
      if (container.clientWidth == container.scrollWidth) {
        $prevElement.hide();
        $nextElement.hide();
      } else {
        $prevElement.show();
        $nextElement.show();
      }
      if (container.scrollLeft == 0) {
        $prevElement.addClass("disabled");
        $nextElement.removeClass("disabled");
      } else if (
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth
      ) {
        $prevElement.removeClass("disabled");
        $nextElement.addClass("disabled");
      } else {
        $prevElement.removeClass("disabled");
        $nextElement.removeClass("disabled");
      }
    }
    reloadButton();
    window.addEventListener("load", () => reloadButton());
    container.addEventListener("scroll", reloadButton);
    window.addEventListener("resize", reloadButton);
  })();
});
